




















import Vue from 'vue'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css';
import SwiperSlide from "@/components/v2/slider/SwiperSlide.vue";
import {Util} from "@/util/util";

interface ComponentData {
  swiper: any,
  hasMultipleSlides: boolean | undefined,
  randomString: string
}

export default Vue.extend({
  name: 'AppSlider',
  components: {SwiperSlide},
  /*
   * This project is developed using Vue.js version 2, therefore, we are utilizing version 5.4.5 of Swiper.js,
   * which is the latest compatible version for our setup.
   *
   * Properties (props) in this context function as parameters for the Swiper instance, enabling configuration
   * and customization according to our specific requirements.
   *
   * For a comprehensive list of all the available parameters in Swiper.js version 5.4.5, kindly refer to
   * the official API documentation at: https://github.com/nolimits4web/swiper/blob/v5/API.md
   */
  props: {
    slidesPerView: {
      type: String,
      default: 'auto'
    },
    spaceBetween: {
      type: Number,
      default: 32
    },
    grabCursor: {
      type: Boolean,
      default: true
    },
    paginationClickable: {
      type: Boolean,
      default: true
    },
    dynamicBullets: {
      type: Boolean,
      default: true
    },
    dynamicMainBullets: {
      type: Number,
      default: 3
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    showNavigation: {
      type: Boolean,
      default: false
    },
    breakpoints: {
      type: Object,
      default: {}
    },
    centeredSlides: {
      type: Boolean,
      default: true
    },
    watchOverflow: {
      type: Boolean,
      default: false
    }
  },
  data(): ComponentData {
    return {
      randomString: Util.randomString(),
      swiper: null,
      hasMultipleSlides: false,
    };
  },
  mounted() {
    this.hasMultipleSlides = this.$slots.default && this.$slots.default.length > 1;
    this.swiper = new Swiper(`#swiper-container-${this.randomString}`, {
      // Options
      autoHeight: true,
      spaceBetween: this.spaceBetween,
      breakpoints: this.breakpoints,
      autoplay: this.autoplay,
      slidesPerView: this.slidesPerView,
      centeredSlides: this.centeredSlides,
      centeredSlidesBounds: false,
      grabCursor: this.grabCursor,
      watchOverflow: this.watchOverflow,
      pagination: this.hasMultipleSlides ? {
        el: '.swiper-pagination',
        clickable: this.paginationClickable,
        dynamicBullets: this.dynamicBullets,
        dynamicMainBullets: this.dynamicMainBullets
      } : false,
      navigation: this.hasMultipleSlides || this.showNavigation
          ? {nextEl: `#next-${this.randomString}`, prevEl: `#prev-${this.randomString}`}
          : false,
    });
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  },
})
